export default __webpack_public_path__ + "static/media/d5ed42cbe4133026b0b4022573cef405.svg";